import React from "react";
import { FaArrowDown } from "react-icons/fa";
import { IMAGE_BASE_URL } from "../data/baseURL";
import DirectorsDetailsModal from "./directoes-details-modal";

const AboutManagementTeam = ({ team, index }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [selectedUserIndex, setSelectedUserIndex] = React.useState(null);

  const close = () => setShowModal(false);

  function handleShowUserInfo(selectedIndex) {
    setShowModal(true);
    setSelectedUserIndex(selectedIndex);
  }

  return (
    <div className="col-12 col-md-6 col-lg-4 ">
      <div className="mx-2 my-5 review-shadow bg-white rounded-lg position-relative">
        <div>
          <img
            src={`${IMAGE_BASE_URL}/${team?.image}`}
            loading="lazy"
            alt={team?.name}
            className="img-fluid w-100"
            style={{
              borderRadius: "1rem 1rem 0 0",
            }}
          />
        </div>
        <div className="p-3">
          <h4 className="fs-22 lh-22 mt-2">{team?.name}</h4>
          <p className="fs-14">{team?.designation}</p>
          <button
            className="text-secondary flex align-items-center fs-12 text-decoration-none text-success bg-white border-0 pb-5"
            onClick={() => handleShowUserInfo(index)}
          >
            <span className="text-spanish-gray">
              <FaArrowDown />
            </span>
            <span className="ms-3 fs-14 text-orange-ryb">View Profile</span>
          </button>
          <div className="review-card-border"></div>
        </div>
      </div>
      <React.Suspense fallback="">
        {showModal && (
          <DirectorsDetailsModal
            userInfo={team}
            text_1="Skills and Experience"
            text_2="Other Appointments"
            showDialog={showModal}
            close={close}
          />
        )}
      </React.Suspense>
    </div>
  );
};

export default AboutManagementTeam;
